import type { ComponentPropsWithoutRef } from 'react';

type Props = Omit<ComponentPropsWithoutRef<'svg'>, 'xmlns' | 'version' | 'viewBox' | 'className'>;

const Icon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="16 16 32 32"
    className="icon"
    {...props}
  >
    <path d="M46.804,34.219c0.179,3.128-6.415,10.197-7.82,4.58c-0.414-1.655,0.806-3.86,1.905-5.034 c0.877-0.937,3.26-2.676,4.614-2.312c0.515,0.139,1.057,0.698,1.159,1.126L46.804,34.219z" />
    <path d="M38.589,32.38c-4.919-0.719-1.104-7.935,1.369-9.446c2.494-1.524,5.354,0.637,4.918,3.456 C44.551,28.494,41.014,32.735,38.589,32.38z" />
    <path d="M37.197,19.278c1.996,2.27-2.691,9.045-5.34,8.312c-4.923-1.363-0.48-8.416,1.495-9.475 c0.671-0.36,1.341-0.582,2.183-0.27L37.197,19.278z" />
    <path d="M22.058,28.788c-2.339-2.141,0.838-8.034,3.039-9.299c3.92-2.253,3.392,5.612,2.012,7.496 c-0.858,1.172-2.537,2.562-3.989,2.618L22.058,28.788z" />
    <path d="M36.151,41.028c-0.003,0.132,0.003,0.234,0.019,0.295c0.493,1.816,1.522,3.409-0.036,5.133 c-1.427,1.579-4.028,1.509-5.731,0.345c-1.638-1.12-2.027-3.49-3.449-4.853c-1.705-1.634-3.554-1.703-5.701-2.009 c-2.349-0.335-3.406-2.041-3.771-4.325c-0.376-2.355,0.885-3.062,3.061-3.379c1.45-0.211,2.958-0.352,4.245-1.081 c2.406-1.364,2.797-3.668,5.762-1.705c1.754,1.161,3.994,2.469,5.233,4.215c0.733,1.033,1.435,1.805,1.283,2.982 C36.879,38.107,36.191,39.452,36.151,41.028z" />
  </svg>
);
export default Icon;
